/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
==========================================================================================*/


import Vue from 'vue'
import Router from 'vue-router'
import store from "src/store/store.js";

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return {
      x: 0,
      y: 0
    }
  },
  routes: [
    {
      path: '/pwa-transaction-receipt',
      name: 'pwa-transaction-receipt',
      component: () => import('@/views/PwaTransactionReceipt'),
      // props: {nextRoute: '/panel/orders'}
    },


    // {
    //   // =============================================================================
    //   // Landing LAYOUT ROUTES
    //   // =============================================================================
    //   path: '',
    //   component: () => import('./layouts/landing/Landing.vue'),
    //   children: [
    //     // =============================================================================
    //     // Theme Routes
    //     // =============================================================================
    //     {
    //       path: '/',
    //       name: 'home',
    //       component: () => import('./views/Home.vue')
    //     }, {
    //       path: '/contact-us',
    //       name: 'contact-us',
    //       component: () => import('./views/pages/ContactUS.vue')
    //     },
    //     {
    //       path: '/portfolio',
    //       name: 'portfolio',
    //       component: () => import('./views/Portfolio.vue')
    //     },
    //     {
    //       path: '/funds',
    //       name: 'funds',
    //       component: () => import('./views/Funds.vue')
    //     },
    //     {
    //     //   path: '/funds/fund-detail',
    //     //   name: 'fund-detail',
    //     //   component: () => import('@/components/landing/FundDetail.vue')
    //     // },
    //     // {
    //       path: '/about',
    //       name: 'about',
    //       component: () => import('./views/About.vue')
    //     },
    //     {
    //       path: '/blog/:urlKey/:id',
    //       name: 'blogPost',
    //       props: true,
    //       component: () => import('./views/BlogPost.vue')
    //     },
    //   ],
    // },
    {
      // =============================================================================
      // UserInfo LAYOUT ROUTES
      // =============================================================================
      path: '',
      component: () => import('./layouts/account/Account.vue'),
      children: [{
        path: '/',
        name: '/main-page',
        component: () => import('@/views/pages/NewLoginRegister')
        },
        {
          path: '/login',
          name: '/login',
        // component: () => import('@/views/pages/Login.vue')
          component: () => import('@/views/pages/NewLoginRegister')
        },
        // {
        //   path: '/register',
        //   name: 'register',
        //   // component: () => import('@/views/pages/Register.vue')
        //  component: () => import('@/views/pages/RegisterNationalId')
        // },
        {
          path: '/forgotPassword',
          name: 'ForgotPassword',
          component: () => import('@/views/pages/ForgotPassword.vue')
        },
      ]
    },
    {
      path: '',
      component: () => import('./layouts/contactUs/Header'),
      children: [
        {
          path: 'contact-us',
          name: 'contact-us',
          component: () => import('./views/pages/ContactUS.vue')
        },
        {
              path: '/portfolio',
              name: 'portfolio',
              component: () => import('./views/Portfolio.vue')
        },
      ]

    },
    {
      // =============================================================================
      // MAIN LAYOUT ROUTES
      // =============================================================================
      path: '/panel',
      component: () => import('./layouts/main/Main.vue'),
      meta: {
        requiresAuth: true
      },
      children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
        {
          path: '',
          name: 'dashboard',
          component: () => import('@/views/panel/Dashboard.vue'),
          meta: {
            largeTitle: 'پیشخوان'
          },
        },
        {
          path: 'confirm-info',
          name: 'confirm-info',
          component: () => import('@/components/register/ConfirmSejamInfo'),
          meta: {
            largeTitle: 'تایید اطلاعات'
          },
          // redirect:to => {
          //   if(store.state.accountInfo.userStatus.key!=='WaitingForEULA'){
          //     return '/panel'
          //   }else{
          //     return 'confirm-info'
          //   }
          // }
        },
        {
          path: 'quizzes',
          name: 'quizzes',
          component: () => import('@/views/panel/Quizzes.vue'),
          meta: {
            largeTitle: 'آزمون ریسک سنجی'
          },
        },
        {
          path: 'user-profile',
          name: 'user-profile',
          component: () => import('@/views/panel/profile/UserProfileInfo.vue'),
          meta: {
            largeTitle: 'اطلاعات کاربر',
            breadcrumb: [{
              title: 'پنل',
              url: '/panel'
            },
              {
                title: 'پروفایل کاربری',
                url: '/panel/user-profile'
              },
              {
                title: 'اطلاعات کاربر',
                url: '/panel/user-profile',
                active: true
              },
            ]
          }
        },
        {
          path: 'deposit',
          name: 'deposit',
          component: () => import('@/views/panel/transactions/Deposit.vue'),
          meta: {
            largeTitle: 'واریز وجه'
          },
        }, {
          path: 'withdraw',
          name: 'withdraw',
          component: () => import('@/views/panel/transactions/Withdraw.vue'),
          meta: {
            largeTitle: 'برداشت وجه'
          },
        }, {
          path: 'account-transaction',
          name: 'account-transaction',
          component: () => import('@/views/panel/transactions/AccountTransaction.vue'),
          meta: {
            largeTitle: 'گزارش حساب',
            innerScroll: true
          },
        },
        {
          path: 'orders',
          name: 'orders',
          component: () => import('@/views/panel/orders/Orders.vue'),
          meta: {
            largeTitle: 'سفارش‌ها',
            innerScroll: true
          },
        },
        {
          path: 'transactionreceipt',
          name: 'transaction-receipt',
          component: () => import('@/views/panel/transactions/TransactionReceipt.vue'),
          props: {nextRoute: '/panel/orders'}
        },
        {
          path: 'announcements',
          name: 'announcements',
          component: () => import('./views/panel/Announcement/Announcements.vue'),
          meta: {
            largeTitle: 'اطلاعیه‌ها'
          },
        },
        {
          path: 'change-password',
          name: 'change-password',
          component: () => import('@/views/panel/profile/ChangePassword.vue'),
          meta: {
            largeTitle: ' رمز عبور'
          },
        },
        {
          path: 'account-security',
          name: 'account-security',
          component: () => import('@/views/panel/profile/AccountSecurity.vue'),
          meta: {
            largeTitle: 'تائید دو‌مرحله‌ای'
          },
        },
        {
          path: 'sessions',
          name: 'sessions',
          component: () => import('@/views/panel/profile/Sessions.vue'),
          meta: {
            largeTitle: 'نشست‌ها'
          },
        },
        {
          path: 'personal-privacy',
          name: 'personal-privacy',
          component: () => import('@/views/panel/profile/PersonalPrivacy.vue'),
          meta: {
            largeTitle: 'امنیت حریم شخصی',
            innerScroll: true
          },
        },
        {
          path: 'ticket',
          name: 'ticket',
          component: () => import('./layouts/ticket/Ticket.vue'),
          children: [

            {
              path: 'new-ticket',
              name: 'newTicket',
              component: () => import('@/views/panel/ticket/NewTicket.vue'),
              meta: {
                largeTitle: 'ایجاد تیکت'
              },
            },
            {
              path: 'ticket-response/:id',
              name: 'ticketResponse',
              component: () => import('@/views/panel/ticket/TicketResponse.vue'),
              meta: {
                largeTitle: 'جزییات تیکت'
              },
            }
          ],
        },
        {
          path: 'fund-info/:id',
          name: 'FundInfo',
          props: true,
          component: () => import('./views/panel/fund/FundInfo.vue'),
          meta: {
            largeTitle: 'صندوق‌های سرمایه‌گذاری'
          },
        },
      ],
    },


    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: '',
      component: () => import('@/layouts/full-page/FullPage.vue'),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================

        {
          path: '/pages/error-404',
          name: 'page-error-404',
          component: () => import('@/views/pages/Error404.vue')
        },
      ]
    },
    // Redirect to 404 page, if no match found
    {
      path: '*',
      redirect: '/pages/error-404'
    }
  ],
})

router.beforeEach((to, from, next) => {
  const appLoading = document.getElementById('loading-bg')
  appLoading.style.display = "block";
  const authToken = store.getters.authToken
  window.scrollTo(0, 0)


 
  if (authToken) {
    if (['/login','/'].some(f => f === to.fullPath) && from.fullPath !=='/panel') {
     
      next('/panel')
      // next()
    }else{
      next()
    }
  }
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!authToken) {
      next('/login')
    } else {
      // if (userStep === 'completed' || userStep=== '') {
      next()
      // } else {
      //   next('/forgotPassword')
      // }
    }
  } else {
    next()
  } 
})

router.afterEach((to, from, failure) => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = "none";
  }
  if (failure) {
    appLoading.style.display = "none";
  }
})

export default router
